import React from 'react';

export const KeyIcon = ({ color = '#2555FE', ...restProps }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M21 3H9C8.20435 3 7.44129 3.31607 6.87868 3.87868C6.31607 4.44129 6 5.20435 6 6V30C6 30.7956 6.31607 31.5587 6.87868 32.1213C7.44129 32.6839 8.20435 33 9 33H27C27.7956 33 28.5587 32.6839 29.1213 32.1213C29.6839 31.5587 30 30.7956 30 30V12L21 3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21 3V12H30" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.5509 21.6367C14.1173 20.5551 14.0704 19.357 14.4182 18.2449C14.766 17.1327 15.4871 16.1748 16.4597 15.5329C17.4322 14.8911 18.5965 14.6047 19.7558 14.7222C20.9152 14.8398 21.9983 15.354 22.8223 16.1779C23.6462 17.0019 24.1604 18.0851 24.278 19.2444C24.3955 20.4037 24.1091 21.568 23.4673 22.5406C22.8254 23.5131 21.8675 24.2342 20.7553 24.582C19.6432 24.9298 18.4451 24.8829 17.3635 24.4493L17.3635 24.4492L16.4377 25.375H14.7502V27.0625H13.0627V28.75H10.2502V25.9375L14.5511 21.6366L14.5509 21.6367Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 19C20.7761 19 21 18.7761 21 18.5C21 18.2239 20.7761 18 20.5 18C20.2239 18 20 18.2239 20 18.5C20 18.7761 20.2239 19 20.5 19ZM22 18.5C22 19.3284 21.3284 20 20.5 20C19.6716 20 19 19.3284 19 18.5C19 17.6716 19.6716 17 20.5 17C21.3284 17 22 17.6716 22 18.5Z"
        fill={color}
      />
    </svg>
  );
};
